var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":"","raised":""}},[_c('v-card-title',[_vm._v("My Record Permissions")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.delegates,"items-per-page":5}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }